import { actionGenerator, IReduxAction } from '../../utils/actions';

type ILoadPublishTermsError = string | void;

export const LOAD_PUBLISH_TERMS_FAIL = 'PUBLISH_TERMS :: LOAD_FAIL';

export type TLoadPublishTermsFailAction = IReduxAction<typeof LOAD_PUBLISH_TERMS_FAIL, ILoadPublishTermsError>;

export const loadPublishTermsFail = actionGenerator<typeof LOAD_PUBLISH_TERMS_FAIL, ILoadPublishTermsError>(
  LOAD_PUBLISH_TERMS_FAIL,
);
